import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/app/(public)/for-consumers/page.tsx");
